import React, {useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { getcomplaint, deletecomplaints } from '../../ReduxToolkit/Slice/Complaint/Complaint';


function Complaint() {
  const dispatch = useDispatch();
  const { status, complaints } = useSelector((state) => state.complaint || { status: 'idle', complaint: { data: [] } });


 
  //  get
  useEffect(() => {
    if (status === "idle") {
      dispatch(getcomplaint())
    }
  }, [dispatch, status]);
  // delete api
  const handleDelete = (complaintid) => {
    const Isconfirmed = window.confirm("Are you sure! you want delete this Complaint Details")
    if (Isconfirmed) {
      dispatch(deletecomplaints(complaintid))
    };
  }
  return (
    <>
      <div>
        <div className='d-flex justify-content-between my-3'>
          <h3>Complaint Forms</h3>
        </div>
        <div className='table-responsive'>
          <table className="table table-hover">
            <thead className="table-primary">
              <tr>
                <th scope="col">S.no</th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">department Name</th>
                <th scope="col">Resaon</th>
                <th scope="col">date</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              {status === "loading" && (
                <tr className='my-2'>
                  <td colSpan={8}>
                    <Skeleton count={10} height={60} />
                  </td>
                </tr>
              )}
              {status === "failed" && (
                <tr>
                  <td colSpan={8}>
                    <p className='text-center fw-bold'>{"Data not found"}</p>
                  </td>
                </tr>
              )}
              {status === "succeeded" && complaints.data && complaints.data.map((complaint, index) => {
                const newdate = new Date(complaint.createdAt);
                const formattedDate = newdate.toLocaleDateString("default", {
                  day: "2-digit",
                  month: "long",
                  year: "numeric"
                });
                return(
                  <tr key={complaint._id}>
                  <th scope="row">{index + 1}</th>
                  <td>{complaint.name}</td>
                  <td>{complaint.email} </td>
                  <td>{complaint.departmentName}</td>
                  <td>{complaint.resaon}</td>
                  <td>{formattedDate}</td>
                  <td className='cursor'>
                  
                    <div onClick={() => handleDelete(complaint._id)}><i className='bi bi-trash text-danger fs-5'></i></div>
                  </td>
                </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
}

export default Complaint;
